import React from "react";
import TaskActionButton from "./TaskActionButton";
import { lang } from "../lang";

function TimerControls({
  task,
  start,
  pause,
  reset,
  onUpdateTask,
  autoCompleteOnTimer,
}) {
  const handleComplete = () => {
    if (process.env.NODE_ENV === "development") {
      console.log("[TimerControls] Completing task manually:", task.id);
    }
    onUpdateTask(task.id, { completed: true, paused: true, remaining: 0 });
  };

  return (
    <div className="timer-controls">
      {!task.completed && !task.isRest && (
        <>
          {task.paused ? (
            <TaskActionButton
              className="play task-action-button-text"
              onClick={start}
              title={lang.task.playAlt}
            >
              Start Timer
            </TaskActionButton>
          ) : (
            <TaskActionButton
              className="pause task-action-button-text" // Using TaskActionButton
              onClick={pause} // No need for e.stopPropagation() here, TaskActionButton handles it
              title={lang.task.pauseAlt}
            >
              Pause Timer{/* Text child */}
            </TaskActionButton>
          )}
          <TaskActionButton
            className="reset task-action-button-text"
            onClick={reset}
            title={lang.task.resetAlt}
          >
            Reset Timer
          </TaskActionButton>
          {!autoCompleteOnTimer && !task.isDeadline && (
            <button
              className="complete" // This button can also be converted to TaskActionButton if desired later
              onClick={(e) => {
                e.stopPropagation();
                handleComplete();
              }}
              style={{
                // Keeping inline style for now for this one
                fontSize: "10px",
                padding: "4px 8px",
                color: "white",
                backgroundColor: "purple", // Example color
                border: "1px solid #ccc",
                cursor: "pointer",
              }}
            >
              Complete
            </button>
          )}
        </>
      )}
    </div>
  );
}

export default TimerControls;
